import PropTypes from 'prop-types';
import { createContext, useEffect, useState } from 'react';
import { getFilters } from 'services/EventFiltersService';

export const EventFiltersContext = createContext({});

export const EventFiltersProvider = (props) => {
  const { children, TileType, itemsPerPage, SortByValue, pageType } = props;
  const [isBusy, setIsBusy] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [eventsData, setEventsData] = useState({ events: [] });
  const [selectedGenreId, setSelectedGenreId] = useState();
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [sortOrder, setSortOrder] = useState(SortByValue);
  const [pageNum, setPageNum] = useState(1);
  const [filterSetModel, setFilterSetModel] = useState({});
  const [startDate, setStartDate] = useState(null);

  const fetchEvents = async () => {
    setIsLoading(true);

    try {
      const response = await getFilters(filterSetModel);

      setEventsData(response);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      console.error(e);
    }
  };

  const fetchMoreEvents = async (requestPayload) => {
    setIsBusy(true);

    try {
      const response = await getFilters(requestPayload);

      if (response.events.length) {
        setEventsData((prevState) => ({
          ...response,
          events: [...(prevState ? prevState.events : []), ...response.events],
        }));
      }
      setIsBusy(false);
    } catch (e) {
      setIsBusy(false);
      console.error(e);
    }
  };

  /**
   * Fetch events on every change of filterSetModel.
   * GenreId from payload can be null or string. Fetch only if:
   * - GenreId is not undefined,
   * - filterSetModel is not empty,
   */
  useEffect(() => {
    if (filterSetModel && filterSetModel.GenreId !== undefined) {
      setPageNum(1);
      fetchEvents();
    }
  }, [filterSetModel]);

  // Create a new filter set to set PageNum when loading more events
  useEffect(() => {
    if (pageNum !== 1) {
      const loadMoreFilterSet = { ...filterSetModel, PageNum: pageNum };
      fetchMoreEvents(loadMoreFilterSet);
    }
  }, [pageNum]);

  useEffect(() => {
    const filtersSet = {
      StartDate: startDate,
      EndDate: null,
      TileType: Number(TileType),
      PageNum: 1,
      SortOrder: Number(sortOrder),
      ItemsPerPage: itemsPerPage,
      GenreId: selectedGenreId,
      Filters: appliedFilters,
      PageType: pageType,
    };

    setFilterSetModel(filtersSet);
  }, [selectedGenreId, sortOrder, appliedFilters, startDate]);

  const value = {
    isBusy,
    setIsBusy,
    isLoading,
    setIsLoading,
    eventsData,
    setEventsData,
    selectedGenreId,
    setSelectedGenreId,
    appliedFilters,
    setAppliedFilters,
    sortOrder,
    setSortOrder,
    setFilterSetModel,
    pageNum,
    setPageNum,
    startDate,
    setStartDate,
  };

  return <EventFiltersContext.Provider value={value}>{children}</EventFiltersContext.Provider>;
};

EventFiltersProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  TileType: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  itemsPerPage: PropTypes.number,
  SortByValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
